<div class="modal custom-modal" id="boardingPlanModal" tabindex="-1" role="dialog"
  aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl zoomIn animated modal-wizard modal-bg-blue"
    role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="text-info">Cage Booking</h5>
        <button type="button" class="close btn-close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body main-modal">
        <div class="wizard custom-plan-list cage-booking-model">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" (navChange)="changeTab($event)"
            class="nav-tabs nav nav-tabs justify-content-start border-0 w-100 flex-nowrap px-2 px-md-0 pb-2 pb-md-0">
            <li [ngbNavItem]="'tab8'" class="flex-fill" id="tab8">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-2 d-none d-lg-block">Date</h6>
                <div class="count">
                  @if(isRightMarkForFirst){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>01</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Date</h4>
                <div class="tab-pane custom-plan-list mt-lg-5">
                  <h6 class="text-primary">Select Date For Booking</h6>
                  <div class="row">
                    <div class="col-lg-6 mb-4">
                      <p-calendar class="form-input form-input-with-box iconic-feild wizard-select" [appendTo]="'body'"
                        (click)="addClassOnDatePicker()" placeholder="Select check-in date" [(ngModel)]="inwardDate"
                        [ngModelOptions]="{ standalone: true }" [minDate]="minInWardDate" [maxDate]="maxDate"
                        [dateFormat]="pCalendarDateFormat" (onSelect)="selectInwardDate()" [readonlyInput]="true"
                        hideOnDateTimeSelect="true" [showIcon]="true" styleClass="p-calendar">
                        <ng-template pTemplate="date" let-date>
                          <span [ngStyle]="{
                            backgroundColor: getSelectedDays(date)
                              ? '#6bb9ff'
                              : 'inherit',
                            color: getSelectedDays(date) ? '#ffffff' : 'inherit'
                          }" class="selected-inward">{{ date.day }}</span>
                        </ng-template>
                      </p-calendar>
                      @if (boardingDateSubmitted && !inwardDate) {
                      <span class="text-danger error">Check-In Date selection is required</span>
                      }
                    </div>
                    <div class="col-lg-6 mb-4">
                      <p-calendar #checkout class="form-input form-input-with-box iconic-feild wizard-select"
                        (click)="addClassOnDatePicker()" [appendTo]="'body'" placeholder="Select check-out date"
                        [(ngModel)]="outwardDate" [ngModelOptions]="{ standalone: true }" [minDate]="inwardDate"
                        [dateFormat]="pCalendarDateFormat" (onSelect)="selectOutwardDate()" [readonlyInput]="true"
                        [showIcon]="true" styleClass="p-calendar">
                        <ng-template pTemplate="date" let-date>
                          <span [ngStyle]="{
                            backgroundColor: getSelectedDays(date)
                              ? '#6bb9ff'
                              : 'inherit',
                            color: getSelectedDays(date) ? '#ffffff' : 'inherit'
                          }" class="selected-outward">{{ date.day }}</span>
                        </ng-template>
                      </p-calendar>
                      @if (boardingDateSubmitted && !outwardDate) {
                      <span class="text-danger error">Check-Out Date selection is required</span>
                      }
                    </div>
                  </div>
                  <div class="d-flex justify-content-lg-end justify-content-center mt-4 ">
                    <a (click)="checkCageAvailability();" class="btn btn-success cursor-pointer">
                      Check Availability</a>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="'tab9'" class="flex-fill" id="tab9" [disabled]="activeTabs.includes('plan')"
              [ngClass]="{ disabled: activeTabs.includes('plan') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-2 d-none d-lg-block">Plan</h6>
                <div class="count">
                  @if(isRightMarkForSecond){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>02</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Plan</h4>
                <div class="tab-pane custom-plan-list mt-lg-5">
                  <div>
                    <h6 class="text-primary"> Board at Safari Veterinary Care Centers</h6>
                    <p>Safari staff are trained to lovingly care for a wide range of pets and give them the best
                      boarding experience possible.</p>
                  </div>

                  @if (cageDetailLoad) {
                  <div class="row col-md-12 mt-5">
                    <app-block-spinner [name]="'cage_detail'" [isSpinnerShow]="cageDetailLoad">
                    </app-block-spinner>
                  </div>
                  }
                  @if (!cageDetailLoad) {
                  <div class="row cage-listing d-flex justify-content-center">
                    <div class="col-xl-4 col-lg-6 col-12 mb-4 ng-star-inserted">
                      <div class="cage-box d-flex flex-column">
                        <div>
                          <figure class="card-figure">
                            <img alt="" class="rounded-3 img-fluid"
                              [src]="filePath +'cage/' + selectedCageTypeId +'/cover_image/' +cageTypeGrid?.cover_image"
                              [alt]="filePath +'cage/' +  selectedCageTypeId +'/cover_image/' + cageTypeGrid?.cover_image"
                              onerror="this.src='assets/images/default_cage.png'">
                          </figure>
                        </div>
                        <h6 class="card-title my-3">
                          Booking
                          {{ cageTypeGrid?.title | titlecase }}&nbsp;
                          <span class="title-type">({{ currentPetType?.name | titlecase }})
                          </span>
                        </h6>
                        @if(cageTypeGrid?.review?.total_review > 0){
                        <p>
                          <app-star-rating [maxScore]="5" [score]="cageTypeGrid?.review?.ratting" [forDisplay]="true">
                          </app-star-rating>&nbsp;({{ cageTypeGrid?.review?.total_review }})
                        </p>
                        }
                        <div class="card-price">
                          <span class="text-info h6"> {{ cageTypeGrid?.amount | currency }} </span>/day
                        </div>
                        <div class="mt-auto">
                          <hr>
                          <div class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
                            <div class="size-area mb-3 mb-lg-0">
                              Size: {{ cageTypeGrid?.width }} x
                              {{ cageTypeGrid?.height }} x
                              {{ cageTypeGrid?.length }} {{ cageTypeGrid?.unit }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a class="btn btn-outline-success cursor-pointer" (click)="goToPrev()">Previous</a>
                    <a class="btn btn-success cursor-pointer" (click)="goToNext('time')">Continue</a>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="'tab10'" class="flex-fill" id="tab10" [disabled]="activeTabs.includes('time')"
              [ngClass]="{ disabled: activeTabs.includes('time') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-2 d-none d-lg-block">Time</h6>
                <div class="count">
                  @if(isRightMarkForThird){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>03</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Time</h4>
                <div class="tab-pane custom-plan-list mt-lg-5">
                  <h6 class="text-primary">Select Time For Drop-off And Pick-up Your Pet</h6>
                  <div class="row">
                    <div class="col-lg-6 mb-4">
                      <p-calendar class="form-input form-input-with-box iconic-feild order-date-picker"
                        (click)="addClassOnDatePicker()" [appendTo]="'body'" [(ngModel)]="inwardTime"
                        [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [hourFormat]="12" [stepMinute]="15"
                        (onSelect)="selectTime('inward')" [showIcon]="true" styleClass="p-calendar">
                        <ng-template pTemplate="date" let-date></ng-template>
                      </p-calendar>
                      @if (errorMessageInWardTime) {
                      <span class="text-danger error">{{errorMessageInWardTime}}</span>
                      }
                    </div>
                    <div class="col-lg-6">
                      <p-calendar #checkout class="form-input form-input-with-box iconic-feild order-date-picker"
                        (click)="addClassOnDatePicker()" [appendTo]="'body'" [(ngModel)]="outwardTime"
                        [ngModelOptions]="{ standalone: true }" [timeOnly]="true" [stepMinute]="15" [hourFormat]="12"
                        (onSelect)="selectTime('outward')" [showIcon]="true" styleClass="p-calendar">
                      </p-calendar>
                      @if (errorMessageOutWardTime) {
                      <span class="text-danger error">{{errorMessageOutWardTime}}</span>
                      }
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="bg-primary rounded-4 p-3 text-white mt-4">
                      Note: Our Normal Working Hours are <span class="text-secondary">Monday to Friday: 06:00
                        AM to 08:00 PM CST, Saturday: 6:00 AM
                        to 6:00 PM CST, Sunday: 9:00 AM - 6:00 PM CST.</span>
                    </div>
                    <p class="text-danger error mb-0 mt-2">{{ errorMessage }}</p>
                  </div>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a class="btn btn-outline-success cursor-pointer" (click)="goToPrev()">Previous</a>
                    <a class="btn btn-success cursor-pointer" (click)="goToNext('pet_details')">Continue</a>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="'tab11'" class="flex-fill" id="tab11" [disabled]="activeTabs.includes('pet_details')"
              [ngClass]="{ disabled: activeTabs.includes('pet_details') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-2 d-none d-lg-block">Pet Details</h6>
                <div class="count">
                  @if(isRightMarkForForth){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>04</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Pet Details</h4>
                <div class="tab-pane custom-plan-list mt-lg-5">
                  <div>
                    <h6 class="text-primary">Pet Details</h6>
                    <p>Please enter your pet's details for our medical records.</p>
                  </div>
                  <form [formGroup]="petDetails" class="pet-detail-form">
                    <div formArrayName="pets">
                      @for (pet of petDetails['controls'].pets['controls']; track pet; let i = $index; let l =
                      $last) {
                      <div class="selection-form pet-selection-form" [formGroupName]="i" id="added_pet_{{ i }}">
                        <div class="row">
                          <div class="col-12">
                            <div class="row my-4">
                              <div class="col-12">
                                <ul class="pet-info shadow-box flex-wrap d-flex gap-3 gap-lg-0">
                                  <li>
                                    <span>Your Pet’s Name</span>
                                    <h6 class="text-info">
                                      {{ pet.controls.name.value }}
                                    </h6>
                                  </li>
                                  <li>
                                    <span>Sex</span>
                                    <h6 class="text-info">
                                      {{
                                      pet.controls.sex.value
                                      ? pet.controls.sex.value
                                      : "N/A"
                                      }}
                                    </h6>
                                  </li>
                                  <li>
                                    <span>Color</span>
                                    <h6 class="text-info">
                                      {{
                                      pet.controls.color.value
                                      ? pet.controls.color.value
                                      : "N/A"
                                      }}
                                    </h6>
                                  </li>
                                  <li>
                                    <span>Age (In Years)</span>
                                    <h6 class="text-info">
                                      {{
                                      pet.controls.age.value
                                      ? pet.controls.age.value
                                      : "N/A"
                                      }}
                                    </h6>
                                  </li>
                                  <li>
                                    <span>weight(In Lbs)</span>
                                    <h6 class="text-info">
                                      {{
                                      pet.controls.weight.value
                                      ? pet.controls.weight.value
                                      : "N/A"
                                      }}
                                    </h6>
                                  </li>
                                  <li>
                                    <span>Breed</span>
                                    <h6 class="text-info">
                                      {{
                                      pet.controls.breed.value
                                      ? pet.controls.breed.value
                                      : "N/A"
                                      }}
                                    </h6>
                                  </li>
                                  <li>
                                    <span>Microchip</span>
                                    <h6 class="text-info">
                                      {{
                                      pet.controls.microchip.value
                                      ? pet.controls.microchip.value
                                      : "N/A"
                                      }}
                                    </h6>
                                  </li>
                                  <li>
                                    <span>identification mark</span>
                                    <h6 class="text-info">
                                      {{
                                      pet.controls.description.value
                                      ? pet.controls.description.value
                                      : "N/A"
                                      }}
                                    </h6>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <h6 class="text-primary my-4">Pet Instruction</h6>
                            <div class="row my-4">
                              <div class="col-12">
                                <div class="shadow-box rounded-4 p-4 p-lg-5">
                                  <ng-container formGroupName="pet_detail">
                                    <div class="row">
                                      <div class="col-lg-6 mb-4">
                                        <input type="text" id="feeding_instruction" name="feeding_instruction"
                                          formControlName="feeding_instruction" trim="blur"
                                          class="form-control input-bg" placeholder="Feeding Instruction" />
                                      </div>
                                      <div class="col-lg-6 mb-4">
                                        <input type="text" id="pet_likes" name="pet_likes" formControlName="pet_likes"
                                          trim="blur" class="form-control input-bg" placeholder="Pet Likes" />
                                      </div>
                                      <div class="col-lg-6 mb-4">
                                        <input type="text" id="pet_dis_likes" name="pet_dis_likes"
                                          formControlName="pet_dis_likes" trim="blur" class="form-control input-bg"
                                          placeholder="Pet Dislikes" />
                                      </div>
                                      <div class="col-lg-6 mb-4">
                                        <input type="text" id="pet_schedule_complete_day"
                                          name="pet_schedule_complete_day" formControlName="pet_schedule_complete_day"
                                          trim="blur" class="form-control input-bg"
                                          placeholder="Pet Schedule Complete Day" />
                                      </div>

                                      <div class="col-lg-6 mb-4 mb-lg-0">
                                        <input type="text" id="care_instruction" name="care_instruction"
                                          formControlName="care_instruction" trim="blur" class="form-control input-bg"
                                          placeholder="Care Instruction" />
                                      </div>
                                      <div class="col-lg-6">
                                        <input type="text" id="allergies" formControlName="allergies" name="allergies"
                                          trim="blur" class="form-control input-bg" placeholder="Allergies" />
                                      </div>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                  </form>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a class="btn btn-outline-success cursor-pointer" (click)="goToPrev()">Previous</a>
                    <a class="btn btn-success cursor-pointer" (click)="goToNext('addons')">Continue</a>
                  </div>

                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="'tab12'" class="flex-fill" id="tab12" [disabled]="activeTabs.includes('addons')"
              [ngClass]="{ disabled: activeTabs.includes('addons') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-2 d-none d-lg-block">Addons</h6>
                <div class="count">
                  @if(isRightMarkForFifth){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>05</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Addons</h4>
                <div class="tab-pane custom-plan-list mt-lg-5">
                  <div>
                    <h6 class="text-primary">Select Addons</h6>
                  </div>

                  <form [formGroup]="petDetails" class="pet-detail-form">
                    <div formArrayName="pets">
                      @for (
                      pet of petDetails['controls'].pets['controls'];
                      track pet;let i = $index; let l =$last) {
                      <div class="selection-form" [formGroupName]="i" id="added_pet_{{ i }}">
                        @if (myAddons.length) {
                        <div class="row my-4">
                          @for (pet_a of pets_array; track pet_a;let pet_i = $index) {
                          @if (pet_a.id == pet.controls.id.value) {
                          @for (addon of myAddons; track addon;let ind = $index) {
                          <div class="col-lg-6 col-xl-4 mb-4"
                            [ngClass]="{'plancard-selected': checkaddonIsExists( pet?.value?.addons,addon.id)}">
                            <div class="inner-box shadow-sm p-4 bg-white rounded-4 inner-box h-100 cursor-pointer"
                              (click)="onSelectAddon( optionModal,'',addon.id,addon,pet.value.id, ind,i); $event.stopPropagation();">
                              <div class="d-flex flex-column h-100">
                                <div class="mb-3">
                                  <div class="d-flex justify-content-between flex-nowrap">
                                    <div>
                                      <h6 class="text-dark" [ngbTooltip]="addon?.title">
                                        {{ addon?.title }}
                                      </h6>
                                      <div class="h6 text-info">
                                        {{addon?.price | currency }} /Day
                                      </div>
                                    </div>
                                    <div class="main-addon-checkbox">
                                      <div class="select-checkbox">
                                        <input type="checkbox" class="form-check-input"
                                          id="addonCheckbox{{ i }}_{{ ind }}"
                                          [checked]="checkaddonIsExists(pet?.value?.addons, addon.id)"
                                          (change)="onSelectAddon(optionModal, addon.id, addon, pet.value.id, ind,i );$event.stopPropagation()" />
                                        <label for="addonCheckbox{{ i }}_{{ ind }}"></label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="camp-plan-mid">
                                    <p>
                                      {{ addon?.description.length > 45
                                      ? ( addon?.description
                                      | slice : 0 : 99) + "..."
                                      : addon?.description}}
                                      @if ( addon?.description.length > 45) {
                                      <a href="javascript:void(0)" class="text-info link"
                                        (click)="$event.stopPropagation();showDescription(addon?.title,addon?.description )">
                                        Read More
                                      </a>
                                      }
                                    </p>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between addon-show-price align-items-center mt-auto">
                                  <div>
                                    @if (addon?.addonCheckoutPrice) {
                                    <span class="addon-style text-info">
                                      {{ addon?.addonCheckoutPrice | currency }}
                                    </span>

                                    }
                                  </div>

                                  @if (
                                  (addon?.options && addon?.options.length &&addon.type ==
                                  'custom') || (addon?.options &&addon?.options.length
                                  &&addon.type !== 'custom') ||(addon?.options == null
                                  &&addon.type == 'custom')
                                  ) {
                                  <a ngbTooltip="Select Option" class="cursor-pointer delete-btn"
                                    (click)="selectOptionModal(optionModal,addon,pet.value.id,i,ind,'edit');$event.stopPropagation()"
                                    aria-hidden="true">
                                    <img [src]="'assets/images/icon/edit.svg'" alt="">
                                  </a>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          }
                          }
                          }
                        </div>
                        }
                      </div>
                      }
                    </div>
                  </form>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a class="btn btn-outline-success cursor-pointer" (click)="goToPrev()">Previous</a>
                    <a class="btn btn-success cursor-pointer"
                      (click)="goToNext(isMandatoryProducts?'mandatory_products':'payment')">Continue</a>
                  </div>
                </div>
              </ng-template>
            </li>
            @if (isMandatoryProducts) {
            <li [ngbNavItem]="'tab13'" class="flex-fill" id="tab13"
              [disabled]="activeTabs.includes('mandatory_products')"
              [ngClass]="{ disabled: activeTabs.includes('mandatory_products') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-2 d-none d-lg-block">Mandatory Products</h6>
                <div class="count">
                  @if(isRightMarkForSixth){
                  <img [src]="'assets/images/wellness-plan/completed.svg'" alt="" />
                  } @else {
                  <span>06</span>
                  }
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Mandatory Products</h4>
                <div class="tab-pane custom-plan-list mt-lg-5">
                  @for (data of mandatoryProductList; track $index) {
                  <div>
                    <h6 class="text-primary">
                      Mandatory vaccinations for &nbsp;{{ data?.pet_name }}
                    </h6>
                  </div>
                  @if (data?.mandatory_products?.length) {
                  <div class="row grooming-modal-vaccination">
                    @for (product of data?.mandatory_products; track product; let i = $index) {
                    <div class="col-12 col-md-6 mb-4 vaccination-modal">
                      <div class="vaccination-box shadow-box cursor-pointer"
                        [ngClass]="{'plancard-selected': selectedProduct.includes(product?.id)}"
                        (click)="selectvaccins(product)">
                        <div class="d-flex justify-content-between mb-2">
                          <div class="d-flex me-4">
                            <ngx-avatars class="rounded-3 img-box me-3 overflow-hidden"
                              [src]="productImagePath +product?.id +'/' +product?.cover_image" [round]="false">
                            </ngx-avatars>
                            <h6 class="text-primary">
                              {{ product?.title }}&nbsp;
                              @if(product?.has_service_in_subscription) {
                              <i class="fa fa-info-circle text-warning"
                                ngbTooltip="This product is already exist in subscription."></i>
                              }
                            </h6>
                          </div>
                          <div class="select-checkbox">
                            <input type="checkbox" id="check_{{ $index }}" class="form-check-input"
                              (click)="selectvaccins(product)" [checked]="selectedProduct.includes(product?.id )" />
                            <label for="check_{{ $index }}"></label>
                          </div>
                        </div>

                        <div class="detail">
                          <div class="d-flex justify-content-between mb-2 align-items-center">
                            <div class="text-info h4">
                              {{ product?.price | currency }}
                            </div>
                            @if (product?.delivery_time) {
                            <span class="badge badge-pill custom-badge badge-info mt-1 mb-1 pt-1"
                              [ngbTooltip]="'Last Delivery Date'">
                              {{ product?.delivery_time | date : format }}
                            </span>
                            }
                          </div>
                          <p class="mb-0">
                            {{
                            product?.description.length > 50? (product?.description | slice : 0 : 50) +"...":
                            product?.description
                            }}
                            @if (product?.description.length > 45) {
                            <a href="javascript:void(0)" class="text-info link"
                              (click)="$event.stopPropagation();showDescription(product?.title, product?.description)">
                              Read More
                            </a>
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  }
                  }
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a class="btn btn-outline-success cursor-pointer" (click)="goToPrev()">Previous</a>
                    <a class="btn btn-success cursor-pointer" (click)="goToNext('payment')">Continue</a>
                  </div>
                </div>
              </ng-template>
            </li>
            }
            <li [ngbNavItem]="isMandatoryProducts?'tab14':'tab13'" class="flex-fill"
              [id]="isMandatoryProducts?'tab14':'tab13'" [disabled]="activeTabs.includes('payment')"
              [ngClass]="{ disabled: activeTabs.includes('payment') }">
              <button ngbNavLink class="w-100">
                <h6 class="m-0 text-start pe-2 d-none d-lg-block">Payment</h6>
                <div class="count">
                  <span>
                    @if (isMandatoryProducts) {
                    07
                    }@else {
                    06
                    }
                  </span>
                </div>
              </button>
              <ng-template ngbNavContent>
                <h4 class="my-4 text-center text-info d-block d-lg-none">Payment</h4>
                <div class="tab-pane order-accordion-inner border-0 mt-lg-5">
                  <div class="row">
                    <div class="col-lg-5 col-12">
                      <h6 class="text-dark mb-3">Cage Summary</h6>
                      <div class="custom-summary-block box-modal">
                        <ul class="type-list">
                          <li>
                            <div class="type-name h6">Cage Name</div>
                            <div class="type-value text-info">{{cageTypeGrid?.title | titlecase }} </div>
                          </li>
                          <li>
                            <div class="type-name h6">Check-In Date</div>
                            <div class="type-value text-info">{{inwardDate | date : format }}</div>
                          </li>
                          <li>
                            <div class="type-name h6">Check-Out Date</div>
                            <div class="type-value text-info">{{ outwardDate | date : format }}</div>
                          </li>
                          <li>
                            <div class="type-name h6">Days Booked</div>
                            <div class="type-value text-info">{{ totalDays }} Day(s)</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-lg-7 col-12 mt-lg-0 mt-4">
                      <h6 class="text-dark mb-3">Payment Summary</h6>
                      <div class="pay-block box-modal">
                        <app-block-spinner [name]="'payment_summary'"
                          [isSpinnerShow]="paymentSummary"></app-block-spinner>
                        @if(!paymentSummary){
                        <ul class="type-list-main">
                          <li class="d-flex justify-content-between">
                            <span class="type-name">Base Amount</span>
                            <span class="type-value h6 text-primary">{{
                              bookingDetails?.cage_price | currency
                              }}</span>
                          </li>

                          @for (pet of bookingDetails.pets; track pet;let i = $index) {
                          <ul class="multiple-type-list">
                            <li class="multi-type-title">
                              <span class="type-name">{{ pet.name }}</span>
                            </li>

                            <li class="d-flex justify-content-between">
                              <span class="type-name">
                                <span class="t-name-desc">
                                  Charge for extra pet in Cage
                                </span>
                              </span>
                              <span class="type-value h6 text-primary">{{ pet.extra_price | currency }}</span>
                            </li>
                          </ul>
                          @if (pet?.addon?.length) {
                          <ul class="multiple-type-list">
                            <li class="multi-type-title">
                              <span class="type-name">Add-ons</span>
                            </li>

                            @for (addon of pet.addon; track addon; let i = $index) {
                            <li class="d-flex justify-content-between">
                              <span class="type-name">
                                <span class="t-name-desc">{{ addon?.title }}
                                  @if (addon?.selected_option) {
                                  <span class="type-name fw-bold" ngbTooltip="Selected Option">- {{
                                    addon?.selected_option
                                    }}
                                  </span>
                                  }
                                  ({{ addon.price | currency }}/Day * {{ addon.days }})
                                </span>
                              </span>
                              <span class="type-value h6 text-primary">{{
                                addon?.total_price | currency
                                }}</span>
                            </li>
                            }
                          </ul>
                          } @if (pet?.products?.length) {

                          <ul class="multiple-type-list">
                            <li class="multi-type-title">
                              <span class="type-name">Mandatory Products</span>
                            </li>

                            @for (product of pet.products; track product;let i = $index) {
                            <li class="d-flex justify-content-between">
                              <span class="type-name">
                                <span class="t-name-desc">{{ product.title }} </span>
                              </span>
                              <span class="type-value h6 text-primary">{{
                                product.price | currency
                                }}</span>
                            </li>
                            }
                          </ul>
                          }
                          }
                          @if (bookingDetails?.discount_detail?.rate) {

                          <li class="d-flex justify-content-between multi-type-title">
                            <span class="type-name">Applied Discount:
                              <span class="credit-amount font-weight-bold">({{
                                bookingDetails?.discount_detail?.title
                                }})</span>
                            </span>
                            <span class="type-value credit-amount h6 text-primary">
                              -{{bookingDetails?.discount_amount | currency }}</span>
                          </li>
                          }
                          <li class="d-flex justify-content-between">
                            <span class="type-name text-info fw-bold">Total Amount Due</span>
                            <span class="type-value h6 text-info fw-bold">{{
                              bookingDetails?.total | currency
                              }}</span>
                          </li>
                        </ul>
                        }

                        <div class="advanced-form">
                          <div class="form-checkbox form-check my-3 py-3 px-sm-5">
                            <input type="checkbox" name="checkbox" id="advancePayCheckbox"
                              [(ngModel)]="is_advance_booking_amount" class="form-check-input">
                            <label for="advancePayCheckbox" class="form-check-label">
                              I would like to pay in advance for this booking
                            </label>
                          </div>
                          @if (is_advance_booking_amount) {
                          <div>
                            <input type="number" [(ngModel)]="updatedAmount"
                              (change)="calculateMinimumAmount(updatedAmount)" class="form-control"
                              placeholder="Amount ($)">
                            <small class="text-danger error">
                              @if (minimumPaymentFlag) {
                              Un-check above check-box to continue without advance payment
                              }
                              @if (maximumPaymentFlag) {
                              Advance Booking Amount should be less than or equal to Total Amount
                              }
                            </small>
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-4 flex-column flex-sm-row gap-3">
                    <a (click)="goToPrev()" class="btn btn-outline-success">Previous</a>
                    <a [disabled]="(is_advance_booking_amount && minimumPaymentFlag) ||(is_advance_booking_amount && maximumPaymentFlag)"
                      [ngClass]="{'disabled': (is_advance_booking_amount && minimumPaymentFlag) ||(is_advance_booking_amount && maximumPaymentFlag)}"
                      (click)="bookingApply()" [ladda]="cartProcess" class="btn btn-success">
                      {{ planDetail?.planEditMode ? "Update" : "Add To" }} Cart
                    </a>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Change Booking Addon Options Modal -->

<ng-template #optionModal let-modal>
  <div class="modal-header">
    <button type="button" class="close btn-close" (click)="closeOptionModal()" data-dismiss="modal" aria-label="Close">
    </button>
  </div>
  <div class="modal-body">
    @if(selectedAddonDetail?.options?.length){
    <h6 class="text-primary mb-2">Select Your Option</h6>
    <div class="row mb-4">
      @for (option of selectedAddonDetail?.options; track option; let ind = $index) {
      <div class="col-md-3 my-2">
        <div class="d-flex align-items-center">
          <input class="form-check-input mt-0 me-2" type="radio" name="option_{{ ind }}" id="option_{{ ind }}"
            [value]="option.value" (change)="changeOption($event, ind)" [checked]="option?.isChecked" />
          <label class="form-check-label" for="option_{{ ind }}">
            {{ option.value }}
          </label>
        </div>
      </div>
      }
    </div>
    }

    @if (selectedAddonDetail?.type == 'custom') {
    <h6 class="text-primary mb-2">Choose Days on which you want add-ons service</h6>

    <div class="row">
      @for (date of formatDates; track date; let i = $index) {
      <div class="col-md-3 my-2">
        <div class="d-flex align-items-center p-3 rounded-4"
          [ngStyle]="{border: date.isChecked ? '1px solid rgba(10,143,230,.5)': '1px solid rgba(10,143,230,.4)', background: date.isChecked ? '#05AAF31A' : '#FFFFFF'}">
          <input class="form-check-input me-2 mt-0" id="date_{{ i }}" type="checkbox"
            (change)="selectDate($event, date)" [checked]="date.isChecked" />
          <label class="form-check-label" for="date_{{ i }}">
            <span class="text-dark">{{ date?.date | date : "d MMM" }}</span>
          </label>
        </div>
      </div>
      }
    </div>
    }
  </div>

  <div class="modal-footer">
    <span [ngbTooltip]="!totalDays ? 'Please select atleast one date.' : ''">
      <button class="btn btn-success" (click)="onSubmit()" [ngClass]="{
          disabled: !totalDays && selectedAddonDetail?.type == 'custom'
        }">
        <span>Submit</span>
      </button>
    </span>
  </div>
</ng-template>